import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import InputField from '../../../reusable-components/InputField';
import { required } from '../../../utils/validations';
import Header from '../../../reusable-components/Header';
import Footer from '../../../reusable-components/Footer';
import Body from '../../../reusable-components/Body';
import Spinner from '../../../reusable-components/Spinner';
import PageContent from '../../../reusable-components/PageContent';
import { ACTIVATE_URL } from '../../../services/api/urls';
import { Row, Col, Button } from 'react-bootstrap';
import { FaArrowRight } from "react-icons/fa";
import PropTypes from 'prop-types';
import '../../../styles/home.less';

export default class Home extends Component {
  render() {
    const { history } = this.props;
    return (
      <>
        <PageContent 
          title="Maak een keuze"
          subtitle="Digitaal vignet"
          cardClass="card-container-custom"
          showFooter={false}>
          <div className="home-logo-container">
            <Row>
              <Col sm={12} md={6} className="col-divider">
                <span 
                  className="instruction-circle circle-logo"
                  onClick={() => {
                    history.push('/extend');
                  }}>
                  <img src={require("../../../assets/buy_vignete.png")} />
                </span>
                <p className="text-muted">Koop Vignet</p>
              </Col>
              <Col sm={12} md={6}>
                <span 
                  className="instruction-circle circle-logo"
                  onClick={() => {
                    history.push('/activate');
                  }}>
                  <img src={require("../../../assets/activate_vignete.png")} />
                </span>
                <p className="text-muted">Activeer Vignet</p>
              </Col>
            </Row>
          </div>
        </PageContent>
      </>
    );
  }
}

Home.propTypes = {
  isloading: PropTypes.bool,
  error_message: PropTypes.string,
  formErrors: PropTypes.object,
  initialValues: PropTypes.object,
}

